(function () {
  const SELECTOR = '[data-applicator-upsell], [data-cart-applicator-upsell]';

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  async function addItems(items) {
    const cart = getCartElement();
    const sections = cart?.getSectionsToRender?.().map((section) => section.section) || [];

    const body = {
      items,
      sections,
      sections_url: window.location.pathname,
    };

    const response = await fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      const message = data.description || data.message || 'Could not add to cart';
      throw new Error(message);
    }

    if (cart && typeof cart.renderContents === 'function') {
      cart.renderContents(data);
    }

    if (typeof window.updateCartCounters === 'function') {
      window.updateCartCounters();
    }

    return data;
  }

  function readMainVariantId(root) {
    const formId = root.dataset.productFormId;
    if (!formId) return null;
    const input = document.querySelector(`#${formId} [name="id"]`);
    return input ? input.value : null;
  }

  (function initCartDrawerApplicatorUpsell() {
    const CONFIG_ID = 'CartDrawer-ApplicatorUpsellConfig';
    const TEMPLATE_ID = 'CartDrawer-ApplicatorUpsellTemplate';
    const TEASER_SELECTOR = '[data-cart-applicator-upsell]';
    const PANEL_SELECTOR = '[data-cart-drawer-upsell-panel]';
    const DISMISS_SELECTOR = '[data-cart-drawer-upsell-dismiss]';
    const CART_MUTATION = /\/cart\/(add|change|update|clear)/i;
    const DISMISS_KEY = 'duffCartApplicatorUpsellDismissed';
    const DISCOUNT_PERCENT = 40;

    function getCopy() {
      const lang = (document.documentElement.lang || '').toLowerCase();
      const host = window.location.hostname || '';
      if (lang.startsWith('sv') || host.includes('.se')) {
        return {
          banner: 'Lägg till applikator | Spara 40 %',
          add: 'Lägg till',
          loading: 'Lägger till…',
          success: 'Tillagd',
          error: 'Försök igen',
          close: 'Stäng',
        };
      }
      if (lang.startsWith('da') || host.includes('.dk')) {
        return {
          banner: 'Få 40 % på Elite Lash Applicator ved køb af Easy Lash',
          add: 'Tilføj',
          loading: 'Tilføjer…',
          success: 'Tilføjet',
          error: 'Prøv igen',
          close: 'Lukk',
        };
      }
      return {
        banner: 'Få 40 % på Elite Lash Applicator ved kjøp av Easy Lash',
        add: 'Legg til',
        loading: 'Legger til…',
        success: 'Lagt til',
        error: 'Prøv igjen',
        close: 'Lukk',
      };
    }

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return `${amount} kr`;
    }

    function isDismissKeySet(key) {
      if (!key) return false;
      try {
        return sessionStorage.getItem(key) === '1';
      } catch (error) {
        return false;
      }
    }

    function dismissPanel(panel) {
      if (!panel) return;
      const key = panel.dataset.cartDrawerUpsellDismissKey || DISMISS_KEY;
      try {
        sessionStorage.setItem(key, '1');
      } catch (error) {
        /* ignore */
      }
      panel.remove();
    }

    function hideDismissedPanels() {
      document.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
        if (isDismissKeySet(panel.dataset.cartDrawerUpsellDismissKey || DISMISS_KEY)) {
          panel.remove();
        }
      });
    }

    function readDomConfig() {
      const node = document.getElementById(CONFIG_ID);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    function resolveConfig() {
      const domConfig = readDomConfig();
      if (!domConfig?.enabled || !domConfig.applicatorProductId || !domConfig.applicatorVariantId) {
        return null;
      }
      return domConfig;
    }

    function isEasyLashCartItem(item, config) {
      const ids = config.easyLashProductIds || [];
      if (ids.includes(item.product_id)) return true;

      const type = String(item.product_type || '')
        .toLowerCase()
        .replace(/-/g, ' ')
        .trim();
      if (type === 'easy lash' || type === 'easy lashes') return true;

      return false;
    }

    function shouldShowApplicatorUpsell(cart, config) {
      if (!config?.enabled || !cart?.items?.length) return false;
      const hasApplicator = cart.items.some((item) => item.product_id === config.applicatorProductId);
      if (hasApplicator) return false;
      return cart.items.some((item) => isEasyLashCartItem(item, config));
    }

    function buildTeaserElement(config) {
      const copy = getCopy();
      const salePrice = Math.round(
        config.applicatorPrice * (100 - (config.discountPercent || DISCOUNT_PERCENT)) / 100
      );
      const comparePrice = config.applicatorPrice;
      const imageHtml = config.applicatorImage
        ? `<img src="${config.applicatorImage}" alt="${config.applicatorTitle || 'Elite Lash Applicator'}" loading="lazy">`
        : '';

      const aside = document.createElement('aside');
      aside.className = 'cart-applicator-upsell';
      aside.setAttribute('data-cart-applicator-upsell', '');
      aside.setAttribute('data-cart-drawer-upsell-panel', '');
      aside.dataset.cartDrawerUpsellDismissKey = DISMISS_KEY;
      aside.dataset.includeMainProduct = 'false';
      aside.setAttribute('aria-label', copy.banner);

      aside.innerHTML = `
        <p class="cart-applicator-upsell__heading">${copy.banner}</p>
        <div class="cart-applicator-upsell__row">
          <div class="cart-applicator-upsell__media">${imageHtml}</div>
          <div class="cart-applicator-upsell__info">
            <p class="cart-applicator-upsell__title">${config.applicatorTitle || 'Elite Lash Applicator'}</p>
            <p class="cart-applicator-upsell__price">
              <del class="cart-applicator-upsell__compare">${formatMoney(comparePrice)}</del>
              <span class="cart-applicator-upsell__sale">${formatMoney(salePrice)}</span>
            </p>
          </div>
          <div class="cart-applicator-upsell__actions">
            <button
              type="button"
              class="cart-applicator-upsell__add"
              data-applicator-upsell-add
              data-upsell-variant-id="${config.applicatorVariantId}"
              data-default-label="${copy.add}"
              data-loading-label="${copy.loading}"
              data-success-label="${copy.success}"
              data-error-label="${copy.error}"
            >${copy.add}</button>
          </div>
        </div>
      `;

      return aside;
    }

    function getTeaserNode(config) {
      const template = document.getElementById(TEMPLATE_ID);
      const fromTemplate = template?.content?.querySelector(TEASER_SELECTOR);
      if (fromTemplate) return fromTemplate.cloneNode(true);
      return buildTeaserElement(config);
    }

    function shouldHideCartDrawerRebuy(cart, config) {
      if (!config?.enabled || !cart?.items?.length) return false;
      return cart.items.some((item) => isEasyLashCartItem(item, config));
    }

    function syncCartDrawerRebuyVisibility(cart, config) {
      const rebuy = document.querySelector('#CartDrawer-Body .cart-drawer__rebuy');
      if (!rebuy) return;
      const hide = shouldHideCartDrawerRebuy(cart, config);
      rebuy.hidden = hide;
      rebuy.style.display = hide ? 'none' : '';
      if (!hide && typeof initCartDrawerRebuy === 'function') {
        initCartDrawerRebuy();
      }
    }

    function applyCartApplicatorUpsell(cart, config) {
      const mount = document.querySelector('.cart-drawer__main');
      document.querySelectorAll(TEASER_SELECTOR).forEach((node) => node.remove());
      syncCartDrawerRebuyVisibility(cart, config);
      if (!mount || !config) return;
      if (isDismissKeySet(DISMISS_KEY)) return;
      if (!shouldShowApplicatorUpsell(cart, config)) return;

      const teaser = getTeaserNode(config);
      if (!teaser) return;

      const cartDrawerItems = mount.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.insertAdjacentElement('afterend', teaser);
      } else {
        mount.append(teaser);
      }
    }

    let syncGeneration = 0;

    function scheduleSync() {
      const generation = ++syncGeneration;
      [300, 900].forEach((delay) => {
        window.setTimeout(() => {
          if (generation === syncGeneration) syncCartApplicatorUpsell();
        }, delay);
      });
    }

    async function syncCartApplicatorUpsell(cart) {
      const config = await resolveConfig();
      if (!config) return;
      try {
        if (!cart || !Array.isArray(cart.items)) {
          cart = await fetch('/cart.js').then((response) => response.json());
        }
        applyCartApplicatorUpsell(cart, config);
      } catch (error) {
        console.error('[cart-applicator-upsell]', error);
      }
    }

    function isCartMutationRequest(input) {
      const url = typeof input === 'string' ? input : input?.url || '';
      return CART_MUTATION.test(url);
    }

    function patchCartMutationListeners() {
      if (window.__cartApplicatorUpsellPatched) return;
      window.__cartApplicatorUpsellPatched = true;

      const originalFetch = window.fetch;
      window.fetch = function patchedCartApplicatorFetch(...args) {
        const result = originalFetch.apply(this, args);
        if (isCartMutationRequest(args[0])) {
          result.then(() => scheduleSync()).catch(() => {});
        }
        return result;
      };
    }

    patchCartMutationListeners();
    document.addEventListener('cart:updated', scheduleSync);

    if (!window.__cartDrawerUpsellDismissInit) {
      window.__cartDrawerUpsellDismissInit = true;
      document.addEventListener('click', (event) => {
        const dismiss = event.target.closest(DISMISS_SELECTOR);
        if (!dismiss) return;
        dismissPanel(dismiss.closest(PANEL_SELECTOR));
      });
    }

    function initCartDrawerUpsellPanels() {
      hideDismissedPanels();
      syncCartApplicatorUpsell();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartDrawerUpsellPanels);
    } else {
      initCartDrawerUpsellPanels();
    }
  })();

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-applicator-upsell-add]');
    if (!button) return;

    event.preventDefault();

    const root = button.closest(SELECTOR);
    if (!root || button.disabled) return;

    const upsellVariantId = button.dataset.upsellVariantId;
    if (!upsellVariantId) return;

    const includeMain = root.dataset.includeMainProduct === 'true';
    const items = [];

    if (includeMain) {
      const mainVariantId = readMainVariantId(root);
      if (mainVariantId) {
        items.push({ id: Number(mainVariantId), quantity: 1 });
      }
    }

    items.push({ id: Number(upsellVariantId), quantity: 1 });

    const loadingLabel = button.dataset.loadingLabel || button.textContent;
    const defaultLabel = button.dataset.defaultLabel || button.textContent;

    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = loadingLabel;

    try {
      await addItems(items);
      button.textContent = button.dataset.successLabel || defaultLabel;
    } catch (error) {
      console.error('[applicator-upsell]', error);
      button.textContent = button.dataset.errorLabel || defaultLabel;
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = defaultLabel;
      }, 1800);
    }
  });
})();
